module.exports = __webpack_public_path__ + "img/erweima.be44c993.jpg";